module.exports = __webpack_public_path__ + "static/media/growth.5d323511.svg";